<template>
    <div class="xtxx">
		<div class="biaoqian">
			<div class="disfac jf">
                <img src="../../assets/wygl/wyf.png" alt="" style="height:20px;width:20px" />
                <span class="xqt">物业费缴纳</span>
            </div>
           <div class="sjyz">
               <input  pattern="[0-9]*"  type="text" placeholder="请输入手机号" v-model="phone">
               <div class="yzm">
                   <input pattern="[0-9]*"  type="text" placeholder="请输入验证码" class="yzminput"  v-model="yzm">
                   <button class="yzmbtn" @click="getyzm" :class="{disab:!timeout}"> <van-count-down :time="time" ref="countDown" format="ss秒后重新获取" v-show="!timeout"  /><span  v-if="timeout">获取验证码</span></button>
               </div>
           </div>
            <div class="bt md20" style="padding-bottom: 40px;">
                <button @click="add" class="btn">提交</button>
            </div> 
		</div>
	</div>
</template>
<script>
import Vue from 'vue';
import { Toast,CountDown} from 'vant';

Vue.use(Toast);
Vue.use(CountDown);
export default {
    data() {
        return {
            time:5 * 1000,
            timeout:true,
            phone:'',
            yzm:'',
            timeval:null
        };
    },
    mounted(){
        Toast('请绑定云商通账号！');
    },
    methods:{
        getyzm(){
            if(this.checkPhone(this.phone).valid){
                this.$axios.get('/api/v1/allinpay/sendVerificationCode',{
                    params:{
                        phone:this.phone
                    }
                }).then(res => {
                    console.log(res)
                    if(res){
                        Toast.success('发送成功！')
                        this.$refs.countDown.reset();
                        this.timeout = false
                        setTimeout(() => {
                            this.timeout = true
                        }, 5000);
                    }
                })
            }else{
                Toast('手机号码不正确');
            }

        },
        djs(){

        },
        checkPhone(value) {
            var reg = /^1[3456789]\d{9}$/; //验证手机号
            if(reg.test(value)){
                return { valid: true }; //验证正确返回valid:true
            }else{
                return { valid: false, msg: "手机号格式错误" }; // 验证错误 返回valid:false;
            }
        },
        handleInput(e) {
            let a = e.key.replace(/[^\d]/g, "");
            if (!a && e.keyCode !== 8) {
                e.preventDefault();
            }
        },
        add(){
            this.$axios.get('/api/v1/allinpay/bindPhone',{
                params:{
                    phone:this.phone,
                    code:this.yzm
                }
            }).then(res => {
                console.log(res)
                if(res){
                    Toast.success('绑定成功！')
                    setTimeout(() => {
                        this.$router.push({ path: "/wyfw/wyjf", query: {} });
                    }, 2000);
                }
            })
        }
    }

}
</script>
<style lang="less" scoped>
.van-count-down{
    color: #fff !important;
}
    .disab{
        pointer-events: none;
        cursor: default;
        opacity: 0.5;
    }
    .sjyz{
        width: 90%;
        margin-left: 5%;
        display: flex;
        flex-direction: column;
        input{
            outline: none;
            border: none;
            height: 60px;
            font-size: 20px;
            border-bottom: 2px solid #f4f4f4;
        }
        .yzm{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .yzminput{
                width: 60%;
            }
            .yzmbtn{
                width: 35%;
                height: 30px;
                outline: none;
                border: none;
                background-color: #00b5ff;
                border-radius: 20px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
	.xtxx {
        width: 100%;
        background-color: #fff;
        .biaoqian {
            width: 100%;
        }

        .jf {
            margin-top: 10px;
            display: flex;
            align-items: center;
            img,
            span,
            div {
                margin-left: 10px;
            }
        }
	}

	.bt {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.md20 {
		margin-bottom: 20px;
	}

	.btn {
		margin-top: 30px;
		outline: none;
		border: none;
		border-radius: 10px;
		color: white !important;
		font-weight: 600;
		background: #28aff6;
		height: 40px;
		width: 70%;
		cursor: pointer;
	}
</style>